import * as React from "react";
import { styled } from "@mui/material";
import clsx from "clsx";
import { memo } from "react";

//region [[ Styles ]]

const CssCollapseContainerView = styled("div")({
  opacity: 0,
  transition: `all 300ms ease-in-out`,
  maxHeight: 0,
  overflow: "hidden",
  "&.in": {
    opacity: 1,
    maxHeight: "500px",
  },
  "&.entering": {
    opacity: 0.1,
  },
  "&.entered": {
    opacity: 1,
  },
  "&.exiting": {
    opacity: 0,
  },
  "&.exited": {
    opacity: 0,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface CssCollapseContainerProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const CSSCollapseTransitionComponent = ({ children, ...props }: any) => {
  // console.log("CSSCollapseTransitionComponent", props);
  return (
    <CssCollapseContainerView className={clsx(props.in ? "in" : "")}>
      {children}
    </CssCollapseContainerView>
  );
};
